import React, { useContext, useState } from "react";
import { Box, TextField, Tab, CircularProgress } from "@mui/material";
import {
  East as EastIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import RichTextEditor from "./RichTextEditor";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { pathJoinUrl } from "@smfa/utils/src";
import { AppContext } from "../context";
import {
  getPatientBanner,
  getPatientIntroduction,
  getPatientQueAnsList,
  addEditPatientBanner,
  addEditPatientIntro,
  addEditPatientQueAns,
  deletepatient,
} from "../actions/patients.actions";
import DeleteModal from "../ui-components/DeleteModal";
import FileUploadArea from "./common/FileUploadArea";
const Patients = () => {
  const [value, setValue] = React.useState("1");

  const { storage } = useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [isshow, setIsshow] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  var addAboutBanner_default = {
    patient_banner_section_id: 0,

    banner_image: "",
    banner_image_name: "",
    banner_image_error: false,
    banner_image_mob: "",
    banner_image_mob_name: "",
    banner_image_mob_error: false,
    banner_title: "",
    banner_title_maxlenth: 30,
    banner_title_error: false,
  };

  var addMembershipHighlight_default = {
    patient_section_id: 0,

    section_title: "",
    section_title_maxlenth: 50,
    section_title_error: false,

    section_description: "",
    section_description_maxlenth: 380,
    section_description_error: false,
  };

  const [addMembershipHighlight, setMembershipHighlight] = useState(
    addMembershipHighlight_default,
  );

  const [addAboutBanner, setAboutBanner] = useState(addAboutBanner_default);

  const [deskimage, setDeskImage] = useState("");
  const onImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files[0]) {
      log.debug(event.target.files[0].name);
      setDeskImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image = event.target.files[0];
      custInfo.banner_image_name = event.target.files[0].name;
      custInfo.banner_image_error = false;
      setAboutBanner(custInfo);
    }
  };

  const [mobimage, setMobImage] = useState("");
  const onMobImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files && event.target.files[0]) {
      setMobImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image_mob = event.target.files[0];
      custInfo.banner_image_mob_name = event.target.files[0].name;
      custInfo.banner_image_mob_error = false;
      setAboutBanner(custInfo);
    }
  };

  const clearBannerUpload = (field, clearPreview) => {
    clearPreview("");
    setAboutBanner((previous) => ({
      ...previous,
      [field]: "",
      [`${field}_name`]: "",
    }));
  };

  const [addData, setVal] = useState("");
  const [memeberList, setMemeberList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [searchText, setSearchText] = useState("");

  const [searchType, setSearchType] = useState("section_quetion");
  const [pageLoader, setPageLoader] = useState(false);

  var addMemeber_default = {
    section_id: 0,

    section_quetion: "",
    section_quetion_maxlenth: 100,
    section_quetion_error: false,
    section_answer: "",
    section_answer_maxlenth: 400,
    section_answer_error: false,
  };

  const [addMemeber, setMemeber] = useState(addMemeber_default);

  const handleChange = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setVal("");
    setLoader(false);
    setValue(newValue);
    setMemeber(addMemeber_default);
  };
  const handleChangeedit = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setValue(newValue);
  };
  const handleChangetab = (e, editor) => {
    setSuccessMsg("");
    setErrorMsg("");
    log.debug(editor);
    var custInfo = { ...addMemeber };
    custInfo.section_answer = editor.getData();
    custInfo.section_answer_error = false;
    setMemeber(custInfo);
    const data = editor.getData();
    setVal(data);
  };
  React.useEffect(() => {
    getPatientBanner().then((res) => {
      log.debug("order_list");
      log.debug(res.data);
      var locInfo = { ...addAboutBanner };
      if (res.data.status === true) {
        locInfo.patient_banner_section_id =
          res.data.data.patient_banner_section_id;

        locInfo.banner_title = res.data.data.banner_title;

        locInfo.banner_image_name = res.data.data.banner_image;
        locInfo.banner_image_mob_name = res.data.data.banner_image_mob;
        log.debug(locInfo);
        setAboutBanner(locInfo);
        if (res.data.data.banner_image !== null) {
          setDeskImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image),
          );
        }
        if (res.data.data.banner_image_mob !== null) {
          setMobImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image_mob),
          );
        }
      } else {
      }
    });

    getPatientIntroduction().then((res) => {
      log.debug("order_list");
      log.debug(res.data);
      var locInfo = { ...addMembershipHighlight };
      if (res.data.status === true) {
        locInfo.patient_section_id = res.data.data.patient_section_id;

        locInfo.section_title = res.data.data.section_title;
        locInfo.section_description = res.data.data.section_description;

        log.debug(locInfo);
        setMembershipHighlight(locInfo);
      } else {
      }
    });
    getPatientQueAnsList({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      log.debug("order_list");
      log.debug(res.data);
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addAboutBannerInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    log.debug(event.target.value);
    if (event.target.name === "banner_title") {
      if (event.target.value.length <= addAboutBanner.banner_title_maxlenth) {
        custInfo.banner_title = event.target.value;
        custInfo.banner_title_error = false;
      }
    }

    setAboutBanner(custInfo);
  };

  const submitLocation = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addAboutBanner };
    log.debug("add");

    if (addAboutBanner.banner_title === "") {
      document.getElementById("banner_title").focus();
      custInfo.banner_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setAboutBanner(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append(
      "patient_banner_section_id",
      addAboutBanner.patient_banner_section_id,
    );
    formData.append("banner_image_mob", addAboutBanner.banner_image_mob);
    formData.append("banner_image", addAboutBanner.banner_image);
    formData.append("banner_title", addAboutBanner.banner_title);

    log.debug(addAboutBanner);

    if (addAboutBanner.patient_banner_section_id === 0) {
      log.debug("add");
      addEditPatientBanner(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Banner  Addedd Successfully!");
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setAboutBanner(addAboutBanner_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setAboutBanner(addAboutBanner_default);
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    } else {
      addEditPatientBanner(formData)
        .then((res1) => {
          log.debug(res1.data);
          if (res1.data.status === true) {
            setSuccessMsg("Banner Updated Successfully!");
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong, please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    }
  };

  const addMembershipHighlightInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addMembershipHighlight };
    log.debug(event.target.value);
    if (event.target.name === "section_title") {
      if (
        event.target.value.length <=
        addMembershipHighlight.section_title_maxlenth
      ) {
        custInfo.section_title = event.target.value;
        custInfo.section_title_error = false;
      }
    }

    if (event.target.name === "section_description") {
      if (
        event.target.value.length <=
        addMembershipHighlight.section_description_maxlenth
      ) {
        custInfo.section_description = event.target.value;
        custInfo.section_description_error = false;
      }
    }
    log.debug(custInfo);

    setMembershipHighlight(custInfo);
  };

  const submitLocationMembershipHighlight = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addMembershipHighlight };
    log.debug("add");

    if (addMembershipHighlight.section_title === "") {
      document.getElementById("section_title").focus();
      custInfo.section_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipHighlight(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipHighlight.section_description === "") {
      document.getElementById("section_description").focus();
      custInfo.section_description_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipHighlight(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append(
      "patient_section_id",
      addMembershipHighlight.patient_section_id,
    );
    formData.append("section_title", addMembershipHighlight.section_title);
    formData.append(
      "section_description",
      addMembershipHighlight.section_description,
    );

    log.debug(addMembershipHighlight);

    if (addMembershipHighlight.patient_section_id === 0) {
      log.debug("add");
      addEditPatientIntro(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Introduction  Addedd Successfully!");
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setMembershipHighlight(addMembershipHighlight_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setMembershipHighlight(addMembershipHighlight_default);
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    } else {
      addEditPatientIntro(formData)
        .then((res1) => {
          log.debug(res1.data);
          if (res1.data.status === true) {
            setSuccessMsg("Introduction Updated Successfully!");
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong, please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    }
  };

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);

    getPatientQueAnsList({
      pageNo: 1,
      perPage: e.target.value,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      log.debug("order_list");
      log.debug(res.data);
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList(res.data.data);
      }
    });
  };

  const changePage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setPageLoader(true);
    setPageNo(page);

    getPatientQueAnsList({
      pageNo: page,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      log.debug("order_list");
      log.debug(res.data);
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList(res.data.data);
      }
      setPageLoader(false);
    });
  };
  const addMemeberInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addMemeber };
    log.debug(event.target.value);
    if (event.target.name === "section_quetion") {
      if (event.target.value.length <= addMemeber.section_quetion_maxlenth) {
        custInfo.section_quetion = event.target.value;
        custInfo.section_quetion_error = false;
      }
    }

    setMemeber(custInfo);
  };

  const submitLocationMember = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addMemeber };
    log.debug("add");

    if (addMemeber.section_quetion === "") {
      document.getElementById("section_quetion").focus();
      custInfo.section_quetion_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMemeber(custInfo);

      setLoader(false);
      return false;
    }
    if (addMemeber.section_answer === "") {
      //  document.getElementById("section_answer").focus();
      custInfo.section_answer_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMemeber(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append("section_id", addMemeber.section_id);
    formData.append("section_quetion", addMemeber.section_quetion);
    formData.append("section_answer", addMemeber.section_answer);

    log.debug(addMemeber);
    if (addMemeber.section_id === 0) {
      log.debug("add");
      addEditPatientQueAns(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setVal("");
            setMemeber(addMemeber_default);
            log.debug(res1.data.status);
            setSuccessMsg("FAQ  Addedd Successfully!");

            setMobImage("");
            getPatientQueAnsList({
              pageNo: pageNo,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              log.debug("order_list");
              log.debug(res.data);

              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setMemeberList(res.data.data);
              } else {
                setMemeberList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "4");
            }, 1000);
          } else {
            setMemeber(addMemeber_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setMemeber(addMemeber_default);
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    } else {
      addEditPatientQueAns(formData)
        .then((res1) => {
          log.debug(res1.data);
          if (res1.data.status === true) {
            setMemeber(addMemeber_default);
            setVal("");
            setSuccessMsg("FAQ Updated Successfully!");

            setMobImage("");
            getPatientQueAnsList({
              pageNo: 1,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              log.debug("order_list");
              log.debug(res.data);
              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setMemeberList(res.data.data);
              } else {
                setMemeberList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "4");
            }, 1000);
          } else {
            setErrorMsg("Something went wrong, please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    }
  };
  const editLocation = (e, val) => {
    var locInfo = { ...addMemeber };
    locInfo.section_id = val.section_id;

    locInfo.section_quetion = val.section_quetion;
    locInfo.section_answer = val.section_answer;
    setVal(val.section_answer);
    log.debug(locInfo);
    setMemeber(locInfo);

    setSuccessMsg("");
    setErrorMsg("");
    const startEvent = new Event("start");

    handleChangeedit(startEvent, "3");
  };

  const checkfilsiw = (newValue) => {
    setErrorMsg("");
    setSearchText("");
    log.debug(newValue);
    if (newValue === "section_quetion") {
      setSearchType("section_quetion");
      document.getElementById("section_quetion").style.display = "block";
    }
  };

  const checkshow = (newValue, off) => {
    if (off === "off") {
      setIsshow("");
    } else {
      setIsshow(newValue);
    }
  };
  const checksortall = (newValue, sort) => {
    let element;
    setErrorMsg("");
    if (newValue === "section_quetion") {
      if (sort === "desc") {
        element = document.getElementById("section_quetionasc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("section_quetiondesc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
      if (sort === "asc") {
        element = document.getElementById("section_quetiondesc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("section_quetionasc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
    }

    setFirstLoading(true);
    getPatientQueAnsList({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
      sort: sort,
      sortvalue: newValue,
    }).then((res) => {
      log.debug(res.data);
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
  };
  const doSearch = (e) => {
    if (e.target.name === "section_quetion") {
      setSearchText(e.target.value);
    }
  };
  const gosubmit = (e) => {
    setErrorMsg("");

    if (searchType === "section_quetion") {
      if (searchText === "") {
        return false;
      }
    }

    setFirstLoading(true);
    getPatientQueAnsList({
      pageNo: 1,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      log.debug(res.data);
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
  };
  const clearfilter = () => {
    setErrorMsg("");
    setSearchText("");

    setMobImage("");
    setSearchType("section_quetion");
    setFirstLoading(true);

    document.getElementById("section_quetion").style.display = "block";
    //  document.getElementById("location").style.display='none';

    setMemeberList([]);
    getPatientQueAnsList({
      pageNo: 1,
      perPage: perPage,
      searchText: "",
      searchType: "section_id",
    }).then((res) => {
      log.debug(res.data);
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
  };

  const resetdoc = () => {
    log.debug("reset");

    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setMemeber(addMemeber_default);

    setVal("");
  };

  const [deleteItem, setDeleteItem] = React.useState(null);
  const handleDelete = (item) => {
    setDeleteItem(item);
  };
  const handleDeleteSuccess = () => {
    setDeleteItem(null);
    setFirstLoading(true);
    getPatientQueAnsList({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      setMemeberList(res.data.data);
      setFirstLoading(false);
    });
  };
  return (
    <>
      <div className="content">
        <div className="body-inner-sec">
          <div className="container-fluid">
            <div className="row">
              <div className="banner-inner-bdy-sec tab-sec-smfa">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Add Banner Section" value="1" />
                        <Tab label="Add Introduction" value="2" />
                        <Tab
                          label={` ${addMemeber.section_id !== 0 ? "Update" : "Add"} FAQ`}
                          value="3"
                        />

                        <Tab label="Manage FAQ" value="4" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div className="banner-inner-bdy-sec tab-sec-smfa">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="banner_title"
                                    label="Title"
                                    variant="standard"
                                    onChange={addAboutBannerInfo}
                                    name="banner_title"
                                    value={addAboutBanner.banner_title}
                                    error={addAboutBanner.banner_title_error}
                                    helperText={` ${addAboutBanner.banner_title_error === true ? "Please enter Title!" : ""}`}
                                  />
                                  <div className="charcter-sec">
                                    {addAboutBanner.banner_title_maxlenth -
                                      addAboutBanner.banner_title.length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addAboutBanner.banner_title_maxlenth -
                                            addAboutBanner.banner_title.length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-5 banner-uplod-secs patients-sec-up">
                            <FileUploadArea
                              title="Add Banner Image For Desktop"
                              description={
                                <>
                                  Best image Resolution: 1920px X 836px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={deskimage}
                              fileName={addAboutBanner.banner_image_name}
                              onChange={onImageChange}
                              deleteRequest={{
                                resource: "patient-banner",
                                id: addAboutBanner.patient_banner_section_id,
                                field: "banner_image",
                              }}
                              onRemove={() =>
                                clearBannerUpload("banner_image", setDeskImage)
                              }
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                          <div className="col-md-5 banner-uplod-secs patients-sec-up">
                            <FileUploadArea
                              title="Add Banner Image For Mobile"
                              description={
                                <>
                                  Best image Resolution: 400px X 350px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={mobimage}
                              fileName={addAboutBanner.banner_image_mob_name}
                              onChange={onMobImageChange}
                              deleteRequest={{
                                resource: "patient-banner",
                                id: addAboutBanner.patient_banner_section_id,
                                field: "banner_image_mob",
                              }}
                              onRemove={() =>
                                clearBannerUpload(
                                  "banner_image_mob",
                                  setMobImage,
                                )
                              }
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 faq-btn">
                            <div className="button-sec patient-btn">
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocation();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Banner Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong, please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div className="baner-tab-add-sec">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-secs  inner-form-secs vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& > :not(style)": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="section_title"
                                  label="Title"
                                  variant="standard"
                                  onChange={addMembershipHighlightInfo}
                                  name="section_title"
                                  value={addMembershipHighlight.section_title}
                                  error={
                                    addMembershipHighlight.section_title_error
                                  }
                                  helperText={` ${addMembershipHighlight.section_title_error === true ? "Please enter Title!" : ""}`}
                                />
                                <div className="charcter-sec">
                                  {addMembershipHighlight.section_title_maxlenth -
                                    addMembershipHighlight.section_title
                                      .length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec">
                                        Max Characters:&nbsp;
                                        {addMembershipHighlight.section_title_maxlenth -
                                          addMembershipHighlight.section_title
                                            .length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>

                          <div className="col-md-8">
                            <div className="form-secs  form-secs-textarea  inner-form-secs vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& .MuiTextField-root": {
                                    m: 1,
                                    width: "25ch",
                                  },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="section_description"
                                  label="Short Description"
                                  placeholder="Short Description"
                                  multiline
                                  rows={2}
                                  variant="standard"
                                  onChange={addMembershipHighlightInfo}
                                  name="section_description"
                                  value={
                                    addMembershipHighlight.section_description
                                  }
                                  error={
                                    addMembershipHighlight.section_description_error
                                  }
                                  helperText={` ${addMembershipHighlight.section_description_error === true ? "Please enter Short Description!" : ""}`}
                                />
                                <div
                                  className="charcter-sec"
                                  style={{ marginTop: "7px" }}
                                >
                                  {addMembershipHighlight.section_description_maxlenth -
                                    addMembershipHighlight.section_description
                                      .length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec max-para">
                                        Max Characters:&nbsp;
                                        {addMembershipHighlight.section_description_maxlenth -
                                          addMembershipHighlight
                                            .section_description.length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec update-mrn"
                              style={{ marginTop: "0px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocationMembershipHighlight();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Introduction Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong, please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="3">
                      <div className="add-patients-sec">
                        <div className="row">
                          <div className="col-md-8">
                            <div className="form-secs inner-form-secs vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& > :not(style)": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="section_quetion"
                                  label="Question"
                                  variant="standard"
                                  onChange={addMemeberInfo}
                                  name="section_quetion"
                                  value={addMemeber.section_quetion}
                                  error={addMemeber.section_quetion_error}
                                  helperText={` ${addMemeber.section_quetion_error === true ? "Please enter Question!" : ""}`}
                                />
                                <div className="charcter-sec">
                                  {addMemeber.section_quetion_maxlenth -
                                    addMemeber.section_quetion.length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec">
                                        Max Characters:&nbsp;
                                        {addMemeber.section_quetion_maxlenth -
                                          addMemeber.section_quetion.length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-8">
                            <div className="answer-secs">
                              <h2>Answer</h2>
                              <RichTextEditor
                                data={addData}
                                onChange={handleChangetab}
                              />

                              <div
                                style={{
                                  marginBottom: "0px",
                                  marginTop: "8px",
                                }}
                              >
                                {addMemeber.section_answer_error === true ? (
                                  <span className="ckvalid">
                                    Please enter Answer
                                  </span>
                                ) : (
                                  <span
                                    className="ckvalid"
                                    style={{ visibility: "hidden" }}
                                  >
                                    Please enter Answer
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row" style={{ marginTop: "0px" }}>
                          <div className="col-md-12">
                            <div
                              className="button-sec update-mrn"
                              style={{ marginTop: "0px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocationMember();
                                  e.preventDefault();
                                }}
                              >
                                {" "}
                                {addMemeber.section_id !== 0
                                  ? "Update"
                                  : "Save"}
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <button
                                type="button"
                                className="btn btn-login btn-reset"
                                onClick={(e) => {
                                  resetdoc();
                                  e.preventDefault();
                                }}
                              >
                                Reset
                              </button>

                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      FAQ Added Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong, please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="4">
                      <div className="table-sec-main">
                        <div className="top-table-sec">
                          <div className="row">
                            <div className="col-md-2 entries-padd">
                              <div className="sota-table-inner">
                                <p>Show Entries</p>
                                <select
                                  className="selectsec"
                                  onChange={perPageChange}
                                  value={perPage}
                                >
                                  <option value={10}>10</option>
                                  <option value={25}>25</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-7">
                              <div className="total-count">
                                {memeberList.length > 0 ? (
                                  <p>
                                    Total
                                    <span className="number-count">
                                      {totalCount}
                                    </span>
                                  </p>
                                ) : null}
                              </div>
                              <div className="tab-manage-sec clear-sec">
                                <button
                                  className=""
                                  onClick={(e) => clearfilter()}
                                >
                                  Clear Filter
                                </button>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="filter-sec">
                                <div
                                  className="form-secs filter-form-sec"
                                  id="section_quetion"
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="standard-basic"
                                      label="Question"
                                      variant="standard"
                                      value={searchText}
                                      name="section_quetion"
                                      onChange={doSearch}
                                    />
                                    <EastIcon onClick={(e) => gosubmit()} />
                                  </Box>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-table-sec">
                            <div className="row">
                              <div className="col-md-12 padding-no">
                                <table
                                  className="table table-bordered"
                                  style={{ marginTop: "0px" }}
                                >
                                  <thead>
                                    <tr className="tab-head-sec">
                                      <th className="admin-sl  serial-sec">
                                        Sl No
                                      </th>

                                      <th
                                        className="tit-sec ques-sec"
                                        onClick={(e) =>
                                          checkfilsiw("section_quetion")
                                        }
                                      >
                                        Question
                                        <span
                                          className="top-sort "
                                          id="section_quetiondesc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-up"
                                            onClick={(e) =>
                                              checksortall(
                                                "section_quetion",
                                                "desc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                        <span
                                          className="bottom-sort  sortopacity"
                                          id="section_quetionasc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-down"
                                            onClick={(e) =>
                                              checksortall(
                                                "section_quetion",
                                                "asc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </th>
                                      <th className="para-sec ans-sec">
                                        Answer
                                      </th>

                                      <th className="action-sec">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {firstLoading ? (
                                      <tr className="td-sec">
                                        <td colSpan={4}>
                                          <div
                                            className="spinner-border"
                                            role="status"
                                            style={{
                                              width: "1rem",
                                              height: "1rem",
                                              marginLeft: "6px",
                                            }}
                                          ></div>
                                        </td>
                                      </tr>
                                    ) : (
                                      <>
                                        {memeberList.length > 0 ? (
                                          memeberList.map((userd, index) => (
                                            <tr
                                              key={index}
                                              className="tab-data-sec"
                                            >
                                              <td className="tab-border-left">
                                                {pageNo * perPage -
                                                  perPage +
                                                  1 +
                                                  index}
                                              </td>
                                              <td>{userd.section_quetion}</td>
                                              <td className="underline-ans">
                                                {userd.section_answer.length >
                                                120 ? (
                                                  <>
                                                    {isshow ===
                                                    userd.section_id ? (
                                                      <>
                                                        <div
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              userd.section_answer,
                                                          }}
                                                        ></div>
                                                        <span
                                                          className="read-grren"
                                                          onClick={(e) =>
                                                            checkshow(
                                                              userd.section_id,
                                                              "off",
                                                            )
                                                          }
                                                        >
                                                          {" "}
                                                          read less
                                                        </span>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <div
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              userd.section_answer.substring(
                                                                0,
                                                                120,
                                                              ),
                                                          }}
                                                        ></div>
                                                        <span
                                                          className="read-grren"
                                                          onClick={(e) =>
                                                            checkshow(
                                                              userd.section_id,
                                                              "show",
                                                            )
                                                          }
                                                        >
                                                          {" "}
                                                          ...read more
                                                        </span>
                                                      </>
                                                    )}
                                                  </>
                                                ) : (
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        userd.section_answer,
                                                    }}
                                                  ></div>
                                                )}
                                              </td>

                                              <td className="edit-sec">
                                                <EditIcon
                                                  onClick={(e) =>
                                                    editLocation(e, userd)
                                                  }
                                                />
                                                <DeleteIcon
                                                  onClick={() =>
                                                    handleDelete(userd)
                                                  }
                                                  className="del-admn-sec"
                                                />
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={4}>No Data Found</td>
                                          </tr>
                                        )}
                                      </>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* pagination start */}
                          {totalPage > 1 ? (
                            <>
                              {pageLoader ? (
                                <div
                                  className="spinner-border"
                                  role="status"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    marginLeft: "6px",
                                    float: "right",
                                    position: "absolute",
                                    bottom: "73px",
                                    right: "35px",
                                  }}
                                ></div>
                              ) : (
                                ""
                              )}

                              <div
                                className="pagination-sec"
                                style={{
                                  boxShadow: "#e29a1217 0px 7px 16px 0px",
                                  width: "auto",
                                  float: "right",
                                  border: "1px solid #0cb8b6",
                                  marginTop: "2px",
                                  marginRight: "20px",
                                  height: "40px",
                                }}
                              >
                                <div
                                  style={{
                                    float: "left",
                                    padding: "0px",
                                    color: "rgb(11, 92, 171)",
                                    fontSize: "14px",
                                    width: "100%",
                                    position: "relative",
                                    display: "inline-flex",
                                  }}
                                >
                                  <div className="pagin-sec">
                                    <i
                                      className="fa-solid fa-angle-left"
                                      onClick={(e) => changePage(pageNo - 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginLeft: "9px",
                                        marginRight: "10px",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "1px",
                                        marginRight: "1px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      Go to{" "}
                                    </span>
                                    <input
                                      className="number-secs"
                                      type="number"
                                      value={pageNo}
                                      onChange={(e) => {
                                        !isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) > 0
                                          ? changePage(parseInt(e.target.value))
                                          : changePage(1);
                                      }}
                                      style={{
                                        color: "rgb(0, 23, 55)",
                                        margin: "9px 6px 0px 4px",
                                        fontSize: "14px",
                                        width: "34px",
                                        height: "22px",
                                        float: "left",
                                        textAlign: "center",
                                        border: "1px solid rgb(114, 114, 114)",
                                        borderRadius: "3px",
                                        outline: "none",
                                      }}
                                    />
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "2px",
                                        marginRight: "2px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      of {totalPage}{" "}
                                    </span>
                                    <i
                                      className="fa-solid fa-angle-right"
                                      onClick={(e) => changePage(pageNo + 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginRight: "6px",
                                        marginLeft: "5px",
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                          {/* pagination end */}
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        open={deleteItem !== null}
        title={"Delete Patient"}
        message={"Are you sure you want to delete this Patient ?"}
        handleClose={() => setDeleteItem(null)}
        handleSuccess={handleDeleteSuccess}
        deleteAction={deletepatient}
        data={deleteItem ? { section_id: deleteItem.section_id } : null}
      />
    </>
  );
};
export default Patients;
